import { memo } from 'react';
import { TYPES } from '../constants';

const StepBusinessType = memo(({ businessType, onChange }) => {
  // businessType is now a comma-separated string like "photographer,videographer"
  const selected = businessType ? businessType.split(',').filter(Boolean) : [];
  const toggle = (key) => {
    const next = selected.includes(key) ? selected.filter(k => k !== key) : [...selected, key];
    onChange(next.join(','));
  };

  return (
    <div className="animate-fadeIn">
      <p className="text-xs font-sans font-medium tracking-widest uppercase mb-2" style={{ color: '#C9A84C', letterSpacing: '0.2em' }}>
        Step 2 of 3
      </p>
      <h2 className="font-serif text-2xl font-bold mb-2" style={{ color: "inherit" }}>
        What do you create?
      </h2>
      <p className="font-sans text-sm mb-6" style={{ color: 'inherit', opacity: 0.5 }}>
        Select all that apply — we&apos;ll tailor your site to showcase each one.
      </p>
      <div className="flex flex-col gap-3">
        {TYPES.map((t) => {
          const isSelected = selected.includes(t.key);
          return (
            <button
              key={t.key}
              onClick={() => toggle(t.key)}
              className="flex items-center gap-4 p-4 rounded-xl border transition-all text-left"
              style={{
                background: isSelected ? 'rgba(201,168,76,0.1)' : 'rgba(128,128,128,0.06)',
                borderColor: isSelected ? '#C9A84C' : 'rgba(128,128,128,0.15)',
                cursor: 'pointer',
              }}
              data-testid={`demo-type-${t.key}`}
            >
              <t.icon size={20} style={{ color: isSelected ? '#C9A84C' : '#8c8782' }} />
              <span className="font-sans text-sm font-medium" style={{ color: 'inherit' }}>
                {t.label}
              </span>
              {isSelected && (
                <span style={{ marginLeft: 'auto', width: '20px', height: '20px', borderRadius: '50%', background: '#C9A84C', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
});

StepBusinessType.displayName = 'StepBusinessType';
export default StepBusinessType;
